<template>
  <div id="priority-controls">
    <div class="truck-configuration">
      <div class="truck-parameters">
        <v-flex>
          <v-text-field
            v-model="truck.width"
            type="number"
            :label="$t('truck_maker.width')"
            step="100"
            min="0"
            box
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="truck.height"
            type="number"
            :label="$t('truck_maker.height')"
            step="10"
            min="0"
            box
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="truck.length"
            type="number"
            :label="$t('truck_maker.length')"
            step="10"
            min="0"
            box
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="truck.max_pallet_weight"
            type="number"
            :label="$t('truck_maker.max_pallet_weight')"
            step="10"
            min="0"
            box
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            v-model="truck.between_pallets"
            type="number"
            :label="$t('truck_maker.spacing_between')"
            step="10"
            min="0"
            box
          ></v-text-field>
        </v-flex>
      </div>
      <div class="truck-orders">
        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">{{ $t("priority_selector.order") }}</th>
                <th scope="col">{{ $t("priority_selector.dispatch_number") }}</th>
                <th scope="col">
                  {{ $t("priority_selector.customer") }}/{{
                  $t("priority_selector.address")
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in orderPriorities" :key="index">
                <td>
                  <div class="color-code" :style="order.style"></div>
                </td>
                <td>{{ order.production_id }}</td>
                <td>
                  <div class="inline">{{ orderPriorities[index].dispatch_priority }}</div>
                  <div class="inline">
                    <button @click="add(order, index)">
                      <v-icon>arrow_downward</v-icon>
                    </button>
                  </div>
                  <div class="inline">
                    <button @click="remove(order, index)">
                      <v-icon>arrow_upward</v-icon>
                    </button>
                  </div>
                </td>
                <td style="width:100px">{{ getOrderText(order) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="truck-controls">
      <div class="mode-changer">
        <v-switch
          v-model="truck.allow_turn"
          :label="$t('priority_controls.allow_turn')"
          :disabled="changeDisabled"
          @change="changeMode($event)"
        ></v-switch>
      </div>
      <div class="confirmation-button">
        <button :disabled="loading">
          <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
          <v-icon
            v-if="!loading"
            large
            color="rgb(25, 118, 210)"
            v-tooltip="$t('priority_controls.optimize_truck')"
            @click="saveChanges"
          >refresh</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Order from "@/models/Order.js";
import Pallet from "@/models/Pallet.js";
import Helper from "@/models/Helper.js";
import User from "@/models/User.js";
import Truck from "@/models/Truck.js";
export default {
  name: "priority-controls",
  props: {
    truck: {
      type: Object,
      required: true
    },
    orders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      prioritiesChanged: false,
      orderPriorities: [],
      changeDisabled: false,
      loading: false,
      colors: [
        "#B5E61D",
        "#FFF200",
        "#99D9EA",
        "#FFAEC9",
        "#FF7F27",
        "#C8BFE7",
        "#00A2E8",
        "#22B14C",
        "#B5E61D",
        "#FFF200",
        "#99D9EA",
        "#FFAEC9",
        "#FF7F27",
        "#C8BFE7",
        "#00A2E8",
        "#22B14C",
        "#B5E61D",
        "#FFF200",
        "#99D9EA",
        "#FFAEC9",
        "#FF7F27",
        "#C8BFE7",
        "#00A2E8",
        "#22B14C"
      ],
      truckCopy: null,
      orderBased: this.getOrderBased()
    };
  },
  watch: {
    orderBased() {
      this.initialize();
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.truckCopy = new Truck(this.truck);
      const orders = Order.sortByPalletPriority(this.truck, this.orders);
      orders.forEach((order, i) => {
        order.style = { background: this.colors[i] };
      });
      this.orderPriorities = this.getOrderPriorities(orders);
    },
    getOrderBased() {
      const user = new User(this.$session.get("user"));
      return user.company_id != 7;
    },
    getOrderPriorities(orders) {
      if (this.orderBased) {
        return orders;
      }
      const grouped = Helper.groupBy(orders, "delivery_address");
      const groupedOrders = [];
      let count = 0;
      for (let group in grouped) {
        const orderGroup = grouped[group];
        groupedOrders.push({
          address_based: true,
          style: { background: this.colors[count] },
          production_id: Order.getProductionIds(orderGroup),
          dispatch_priority: Order.getDispatchPriority(orderGroup),
          customer: orderGroup[0].customer,
          address: orderGroup[0].address,
          orders: orderGroup
        });
        count++;
      }
      return groupedOrders;
    },
    getOrderText(order) {
      const customer = order.customer ? order.customer : "";
      const address = order.address ? order.address : "";
      return customer + "\n" + address;
    },

    async saveChanges() {
      if (this.truck.status >= 4) {
        alert(this.$t("trucks_list.already_confirmed"));
        return;
      }
      this.loading = true;
      const pallets = Pallet.getPalletsPriority(
        this.truck.pallets,
        this.orderPriorities
      );
      this.$store.commit("setLoading", true);
      if (this.truckModified(this.truck, this.truckCopy)) {
        await this.truck.save();
      }
      if (this.prioritiesChanged) {
        await Pallet.updatePallets(pallets, true); // make sure length update is ignored
      }
      await this.truck.optimize(pallets);
      this.loading = false;
      this.$emit("updated");
      this.prioritiesChanged = false;
    },

    truckModified(truck, truckCopy) {
      if (truck.width != truckCopy.width) {
        return true;
      }
      if (truck.height != truckCopy.height) {
        return true;
      }
      if (truck.length != truckCopy.length) {
        return true;
      }
      if (truck.max_pallet_weight != truckCopy.max_pallet_weight) {
        return true;
      }
      if (truck.between_pallets != truckCopy.between_pallets) {
        return true;
      }
      return false;
    },

    async changeMode(event) {
      this.changeDisabled = true;
      this.truck.allow_turn = event;
      await this.truck.save();
      this.changeDisabled = false;
    },

    add(order, index) {
      this.prioritiesChanged = true;
      order.dispatch_priority += 1;
      this.$set(this.orderPriorities, index, order);
    },

    remove(order, index) {
      if (order.dispatch_priority != 1) {
        this.prioritiesChanged = true;
        order.dispatch_priority -= 1;
        this.$set(this.orderPriorities, index, order);
      }
    }
  }
};
</script>

<style>
#priority-controls {
  position: relative;
  width: 100%;
  height: fit-content;
}
.color-code {
  width: 100px;
  height: 50px;
}
.table-wrapper {
  width: 500px;
  margin: 0 auto;
  text-align: left;
}
.inline {
  display: inline-block;
}
th {
  vertical-align: text-top;
}
.mode-changer {
  position: absolute;
  top: -20px;
  left: 20px;
  width: 50px;
  height: 20px;
}
.confirmation-button {
  position: absolute;
  top: 0px;
  left: 120px;
  width: 50px;
  height: 20px;
}
.truck-configuration {
  position: relative;
  width: 100%;
  min-height: 400px;
}
.truck-controls {
  position: relative;
  widows: 100%;
  height: 50px;
}
.truck-parameters {
  position: relative;
  width: 30%;
  min-height: 400px;
}
.truck-orders {
  position: absolute;
  width: 70%;
  height: 400px;
  right: 0;
  top: 0;
  overflow-y: scroll;
}
.truck-orders::-webkit-scrollbar {
  width: 10px;
}

.truck-orders::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.truck-orders::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.order-switch {
  position: relative;
  left: 50px;
  width: 100px;
}
</style>
